var _path, _mask, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16Z",
    fill: "currentColor"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "check_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 7.667,
    y: 9.666,
    width: 17,
    height: 13,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.667 9.666h17v13h-17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.328 19.082 9.85 15.765l-1.184 1.122 4.66 4.446 10.006-9.545-1.175-1.122-8.83 8.416Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.328 19.082 9.85 15.765l-1.184 1.122 4.66 4.446 10.006-9.545-1.175-1.122-8.83 8.416Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m13.328 19.082-.345.362.345.329.345-.329-.345-.362ZM9.85 15.765l.345-.362-.344-.328-.345.327.344.363Zm-1.184 1.122-.344-.363-.382.361.38.363.346-.361Zm4.66 4.446-.345.362.346.33.345-.33-.345-.362Zm10.006-9.545.346.362.379-.362-.38-.362-.345.362Zm-1.175-1.122.345-.361-.345-.33-.345.33.345.361Zm-8.485 8.054-3.477-3.317-.69.724 3.476 3.317.69-.724Zm-4.166-3.318-1.184 1.122.688.726 1.184-1.122-.688-.726ZM8.322 17.25l4.66 4.446.69-.724-4.66-4.446-.69.724Zm5.35 4.446 10.006-9.545-.69-.724-10.005 9.545.69.724Zm10.006-10.269-1.175-1.121-.69.723 1.175 1.122.69-.724Zm-1.865-1.121-8.83 8.415.69.724 8.83-8.416-.69-.723Z",
    fill: "#fff",
    mask: "url(#check_svg__a)"
  })));
};

export default SvgCheck;